import { ArrowLeftIcon } from "@heroicons/react/24/outline";
import { useNavigate } from "react-router-dom";

const BackButton = ({ onClick }) => {
  const navigate = useNavigate();
  const onClickHandler = () => {
    if (onClick) {
      onClick();
      return;
    }
    navigate(-1);
  };
  return (
    <button
      type="button"
      onClick={onClickHandler}
      className="inline-flex items-center rounded-pill bg-white border border-ink-200 px-3.5 py-1.5 text-sm font-medium text-ink-700 hover:bg-cream-100 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent-500 transition-colors duration-150 ease-editorial"
    >
      <ArrowLeftIcon aria-hidden="true" className="-ml-0.5 mr-1.5 size-4" />
      Back
    </button>
  );
};

export default BackButton;
